import { crossLace } from '../../lace/crossCenterOfCrossWeb'

export const w34WebVerticalParts = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.fillStyle = webColor
  // 縦パーツ
  ctx.beginPath()
  ctx.moveTo(630, 120) //左上
  ctx.quadraticCurveTo(587, 214, 494, 311) //左下
  ctx.quadraticCurveTo(493, 353, 534, 355) //右下
  ctx.quadraticCurveTo(658, 225, 668, 175) //右上
  ctx.quadraticCurveTo(650, 141, 630, 120) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 縦向き＿左＿外側
  ctx.moveTo(642, 138) // 上
  ctx.quadraticCurveTo(598, 255, 499, 330) // 下
  // 縦向き＿左＿内側
  ctx.moveTo(644, 140) // 上
  ctx.quadraticCurveTo(600, 257, 501, 332) // 下
  // 縦向き＿右＿内側
  ctx.moveTo(648, 146) // 上
  ctx.quadraticCurveTo(613, 250, 510, 341) // 下
  // // 縦向き＿右＿外側
  ctx.moveTo(650, 150) // 上
  ctx.quadraticCurveTo(615, 252, 512, 343) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  crossLace(ctx, laceColor, -8, 8, 0, 0)
  crossLace(ctx, laceColor, -37, 57, 0, 1)
  crossLace(ctx, laceColor, -75, 105, 0, 1)
}
